(function (root) {
  'use strict';
  function quantity(value) {
    var raw = value == null ? '' : String(value);
    var number = Number(raw);
    return /^\d+$/.test(raw) && Number.isSafeInteger(number) && number >= 1 ? number : '';
  }
  function mailHref(data) {
    var count = quantity(data.lineQuantity);
    var body = ['【タイヤの適合・商品相談】', '商品：' + (data.productTitle || '未指定'), 'サイズ：' + (data.productSize || '未指定'), '希望本数：' + (count === '' ? '未入力' : count + '本'), '相談内容：', 'URL：' + (data.productUrl || '')].join('\n');
    return 'mailto:yorozu-ec-division@yorozubutsuryu.jp?subject=' + encodeURIComponent('タイヤの適合・商品相談') + '&body=' + encodeURIComponent(body);
  }
  function inputQuantity(input, scope) {
    if (!input) return undefined;
    var productId = scope ? scope.getAttribute('data-cro-selected-product-id') : '';
    if (input.name !== 'quantity' ||
      (productId !== '10450408046759' && productId !== '11205942214823')) return input.value;
    if (input.getAttribute('aria-invalid') === 'true') return '';
    var count = quantity(input.value);
    var units = quantity(scope.getAttribute('data-cro-units-per-item'));
    var actual = count === '' || units === '' ? NaN : count * units;
    return Number.isSafeInteger(actual) && actual >= 1 ? actual : '';
  }
  var api = { normalizeQuantity: quantity, mailHref: mailHref, inputQuantity: inputQuantity };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  root.ChaoyangStorefrontSupport = api;
  var doc = root.document;
  function update(card, value) {
    if (value !== undefined) card.dataset.lineQuantity = String(quantity(value));
    var email = card.querySelector('[data-photo-consult-email]');
    if (email) email.href = mailHref(card.dataset);
  }
  function init() {
    doc.querySelectorAll('[data-photo-consult-card]').forEach(function (card) {
      var scope = card.closest('[data-cro-product], [data-quote-product-detail]');
      var input = scope && scope.querySelector('[data-cro-quantity-input], [data-quote-quantity-input]');
      update(card, inputQuantity(input, scope));
    });
    var dock = doc.querySelector('[data-quote-mobile-dock]');
    if (dock) {
      function measure() { doc.documentElement.style.setProperty('--quote-product-dock-height', Math.ceil(dock.getBoundingClientRect().height) + 'px'); }
      measure();
      if (root.ResizeObserver) new root.ResizeObserver(measure).observe(dock);
      root.addEventListener('resize', measure, { passive: true });
    }
  }
  doc.addEventListener('chaoyang:quantity-change', function (event) {
    var scope = event.target && event.target.querySelectorAll ? event.target : doc;
    scope.querySelectorAll('[data-photo-consult-card]').forEach(function (card) { update(card, event.detail ? event.detail.quantity : ''); });
  });
  doc.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('[data-cro-quantity-input], [data-quote-quantity-input]')) return;
    var scope = event.target.closest('[data-cro-product], [data-quote-product-detail]');
    if (scope) scope.querySelectorAll('[data-photo-consult-card]').forEach(function (card) { update(card, inputQuantity(event.target, scope)); });
  });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})(typeof window !== 'undefined' ? window : null);
